import { Box, Button, Stack, Typography } from "@mui/material";

/** Whether a task is done — independent of its column. Shared between the
 *  drawer and the board card so the two never disagree about what the
 *  checkmark means. */
export default function DoneToggle({ done, disabled = false, onChange }) {
  return (
    <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
      <Button
        size="small"
        variant={done ? "contained" : "outlined"}
        color={done ? "success" : "inherit"}
        disabled={disabled}
        onClick={() => onChange(!done)}
        startIcon={done ? <Box component="span">&#10003;</Box> : null}
      >
        {done ? "Done" : "Mark done"}
      </Button>
      {done ? (
        <Typography variant="caption" color="text.secondary">
          Counted in its epic's rollup as shipped.
        </Typography>
      ) : null}
    </Stack>
  );
}
